import React from 'react';
import classNames from 'classnames/dedupe';
import PropTypes from 'prop-types';

import { getValidDOMProps } from './Utils/reactprops';
import './stylesheets/ActionMenuContainers.scss';

export const ActionMenuGroup = (props) => {
  const { title, type, children } = props;

  const classes = {
    loc: true,
    'action-menu-group': true,
    'action-menu-group-footer': type === 'footer'
  };

  return (
    <div className={classNames(classes)}>
      { title ? <div className="action-menu-group-title">{ title }</div> : null }
      { children }
    </div>
  );
};

ActionMenuGroup.propTypes = {
  /** Action menu group title */
  title: PropTypes.string,
  /** Set to 'footer' to get footer type styles */
  type: PropTypes.string,
  /** Any number of ActionMenuItem components */
  children: PropTypes.node
};

export class ActionMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.styleAdjustments = {
      right: { left: 72, top: 0 },
      left: { left: -40, top: 0 }
    };
  }

  getStyles(align, top = 0, left = 0, offsetLeft = 0, offsetTop = 0) {
    const defaultPlacement = { left: 0, top: 0 };
    const styleAdjustment = this.styleAdjustments[align] || defaultPlacement;

    return {
      left: top + styleAdjustment.left + offsetLeft,
      top: left + styleAdjustment.top + offsetTop
    };
  }

  render() {
    const { title, className, align, offsetLeft, offsetTop, children } = this.props;
    const validDomProps = getValidDOMProps(this.props, ActionMenu);

    // positionLeft and positionTop are passed down by OverlayTrigger to position
    // the overlay next to the element that trigger it.
    const { positionLeft, positionTop } = this.props;
    const style = this.getStyles(align, positionLeft, positionTop, offsetLeft, offsetTop);

    const classes = { loc: true, 'action-menu': true };

    return (
      <div className={classNames(classes, className)} {...validDomProps} style={style} >
        { title ? <div className="action-menu-title">{ title }</div> : null }
        { children }
      </div>
    );
  }
}

ActionMenu.propTypes = {
  /** Action menu title */
  title: PropTypes.string,
  /** Any number of ActionMenuGroup or ActionMenuItem components */
  children: PropTypes.node,
  /** class to be used on  */
  className: PropTypes.string,
  /** alignment for the action menu, left or right */
  align: PropTypes.oneOf(['left', 'right']),
  /** integer offset used in the style of the div */
  offsetLeft: PropTypes.number,
  /** integer offset used in the style of the div */
  offsetTop: PropTypes.number,

  /** passed by OverlayTrigger */
  positionLeft: PropTypes.number,
  /** passed by OverlayTrigger */
  positionTop: PropTypes.number
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/ActionMenuContainers.jsx